import React from 'react';

import BlueprintArticleCard from './BlueprintArticleCard';
import SectionHeader from './SectionHeader';
import { Section } from './types';

interface BlueprintArticleSectionProps {
  section: Section;
}

const BlueprintArticleSection = ({ section }: BlueprintArticleSectionProps) => {
  return (
    <article>
      <SectionHeader title={section.title} anchorId={section.anchorId} />
      <div className="mt-40 grid grid-cols-1 gap-y-40 sm:grid-cols-2 sm:gap-x-[52px] lg:grid-cols-3 lg:gap-x-24 lg:gap-y-64">
        {section.items.map((item) => (
          <BlueprintArticleCard key={item.id} item={item} />
        ))}
      </div>
    </article>
  );
};

export default BlueprintArticleSection;
